import { Link } from "react-router-dom";
import { ArrowLeft, ArrowUpRight } from "lucide-react";
import Footer from "@/components/Footer";

export function SubNav() {
  return (
    <header
      className="sticky top-0 z-50 bg-[#FFFFFF]/95 backdrop-blur-sm border-b border-[#0A0A0A]"
      data-testid="case-study-nav"
    >
      <div className="max-w-[1440px] mx-auto px-4 md:px-8 h-16 flex items-center justify-between">
        <Link
          to="/"
          className="flex items-baseline gap-2.5 group"
          data-testid="case-study-nav-logo"
        >
          <span className="font-display text-xl tracking-tighter leading-none">
            PARAUX
          </span>
          <span className="label-mono text-[#595959] leading-none">
            Design studio
          </span>
        </Link>

        <Link
          to="/#work"
          className="label-mono hidden md:inline-flex items-center gap-2 hover:text-[#4C1D95] transition-colors"
          data-testid="case-study-back-link"
        >
          <ArrowLeft size={14} strokeWidth={1.5} /> All work
        </Link>

        <Link
          to="/#contact"
          className="bg-[#0A0A0A] text-[#FFFFFF] px-4 py-2 label-mono border border-[#0A0A0A] hover:bg-[#4C1D95] hover:border-[#4C1D95] transition-colors"
          data-testid="case-study-nav-cta"
        >
          Get in touch ↗
        </Link>
      </div>
    </header>
  );
}

export function NotFound() {
  return (
    <div className="min-h-screen bg-[#FFFFFF] text-[#0A0A0A] flex flex-col">
      <SubNav />
      <div className="flex-1 flex flex-col items-center justify-center gap-6 px-4 text-center">
        <p className="label-mono text-[#595959]">Error / 404</p>
        <h1 className="font-display text-5xl md:text-7xl tracking-tighter">
          Case study
          <br /> not found.
        </h1>
        <Link
          to="/#work"
          className="inline-flex items-center gap-2 border border-[#0A0A0A] px-6 py-3 label-mono hover:bg-[#0A0A0A] hover:text-[#FFFFFF] transition-colors"
          data-testid="notfound-back"
        >
          <ArrowLeft size={16} strokeWidth={1.5} /> Back to work
        </Link>
      </div>
    </div>
  );
}

export function ComingSoon({ s }) {
  return (
    <div
      className="min-h-screen bg-[#FFFFFF] text-[#0A0A0A] flex flex-col"
      data-testid="case-study-coming-soon"
    >
      <SubNav />
      <main className="flex-1">
        <section className="border-b border-[#0A0A0A]">
          <div className="max-w-[1440px] mx-auto px-4 md:px-8 py-24 md:py-36">
            <div className="flex items-center justify-between flex-wrap gap-4 mb-10">
              <p className="label-mono text-[#595959]">
                / {s.id} — Case study
              </p>
              <p className="label-mono text-[#4C1D95] flex items-center gap-2">
                <span className="w-2 h-2 bg-[#4C1D95] blink" /> Write-up in
                progress
              </p>
            </div>
            <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl tracking-tighter">
              {s.title}
            </h1>
            <p className="font-display text-2xl md:text-3xl tracking-tighter text-[#4C1D95] mt-4 max-w-3xl">
              {s.subtitle}
            </p>
            <p className="max-w-2xl text-lg md:text-xl leading-relaxed mt-8 text-[#595959]">
              {s.teaser}
            </p>
            <div className="mt-12 flex flex-wrap gap-4">
              <Link
                to="/#contact"
                className="inline-flex items-center gap-2 bg-[#4C1D95] text-[#FFFFFF] px-6 py-4 label-mono hover:bg-[#0A0A0A] transition-colors"
                data-testid="coming-soon-contact"
              >
                Request a walkthrough <ArrowUpRight size={16} strokeWidth={1.5} />
              </Link>
              <Link
                to="/#work"
                className="inline-flex items-center gap-2 border border-[#0A0A0A] px-6 py-4 label-mono hover:bg-[#0A0A0A] hover:text-[#FFFFFF] transition-colors"
                data-testid="coming-soon-back"
              >
                <ArrowLeft size={16} strokeWidth={1.5} /> See more work
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
